import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 退货
 * @author shendeying
 */
import config from '$config';
import CommonUtils from 'utils/CommonUtils';
import api from 'api/order';
import { mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
export default {
  name: 'page-back-goods-apply',
  data: function data() {
    return {
      tableData: [],
      remark: null,
      itemIdList: [],
      backInfo: {
        backgoodsreason: null,
        canceldesc: null,
        orderImg: null,
        id: null,
        itemIdList: []
      },
      backgoodsreasonPicker: false,
      backgoodsreasonList: ['不想要', '材质规格与产品描述不符', '少件/漏发', '收到的产品有破损', '发票有问题', '卖家发错货', '其他']
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    screen: GET_SCREEN
  })), {}, {
    fileURL: function fileURL() {
      return config.fileURL;
    },
    totalPrice: function totalPrice() {
      var price = 0;
      this.itemIdList.forEach(function (item) {
        price = price + item.amount;
      });
      return price;
    }
  }),
  watch: {},
  methods: {
    cloneObject: CommonUtils.cloneObject,
    backgoodsreasonSelected: function backgoodsreasonSelected(value) {
      this.backInfo.backgoodsreason = value;
      this.backgoodsreasonPicker = false;
    },
    backgoodsreasonApplySubmit: function backgoodsreasonApplySubmit() {
      var _this = this;

      this.itemIdList.forEach(function (item) {
        _this.backInfo.itemIdList.push(String(item.id));
      });
      api.backGoodsApply(this.backInfo).then(function (res) {
        if (res.type === 'SUCCESS') {
          _this.$router.push({
            name: 'orderDetail',
            query: {
              id: _this.backInfo.id
            }
          });
        }
      });
    },
    handleUploadOrderImg: function handleUploadOrderImg(img) {
      this.backInfo.orderImg = img;
    }
  },
  mounted: function mounted() {
    this.backInfo.id = this.$route.query.id;
    this.tableData = this.$route.query.tableData;
    this.remark = this.$route.query.remark;
  },
  components: {}
};